import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'

Vue.use(VueRouter)

const routes = [{
		path: '/',
		name: 'index',
		component: index
	},
	{
		path: '/Index',
		name: 'index',
		component: index
	},
	{
		path: '/configuration',
		name: 'configuration',
		component: () => import('../views/configuration.vue')
	}
]

const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes
})

export default router